function Container({ PropComponent, heading, text }) {
  return (
    <div className='font-display sm:w-1/2 mx-10 mt-36 lg:mt-40 flex items-center justify-center shadow-xl rounded-2xl pb-2 text-center' /*className="flex items-center justify-center m-2 sm:m-2 md:m-2 lg:m-4 lg:min-h-screen"*/>
      <div className='md:w-full space-x-2 mx-auto pb-2 bg-white' /*className="w-full sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl p-4"*/>
        <div className='container horizontal' /*className="bg-slate-200 rounded-lg max-w-lg p-4"*/>
          {heading && (
            <h1 className="text-red-900 font-bold text-center text-2xl lg:text-3xl">
              {heading}
            </h1>
          )}
          {text && (
            <p className="text-center py-2 text-md font-light text-red-900">
              {text}
            </p>
          )}
          <div /*className="text-center"*/>
            <PropComponent />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Container;